export default {
  namespaced: true,

  getters: {
    enabled(state, getters, rootState, rootGetters) {
      if (!rootGetters['builder/entity/enabled']) {
        return false;
      }

      return !!rootGetters['builder/config'].entities
        .label_plural;
    },

    required(state, getters) {
      return getters.enabled;
    },
  },
};
